"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
const valueIsBoolean_1 = __importDefault(require("../../typeAssertions/valueIsBoolean"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const valueIsNumber_1 = __importDefault(require("../../typeAssertions/valueIsNumber"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getDbPathFromArrayOfValues_1 = __importDefault(require("../getDbPathFromArrayOfValues"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const getDataDB = ({ isDevelopment }) => async ({ functionId, entryVars: { pathOnDb: arrayPath, isRealTime, timeToRefresh: timeToRefreshEntry, shouldUpdateDbCache = false, filter: filterEntry, orderBy: orderByEntry, limitToFirst, limitToLast, startAt: startAtEntry, endAt: endAtEntry, }, callbacks, executeProcesses, processor, }) => {
    const { updateRenderDBCache, databaseCore } = processor.root;
    let filter;
    let startAt;
    let endAt;
    if ((0, valueIsNumber_1.default)(filterEntry) || (0, valueIsString_1.default)(filterEntry)) {
        filter = filterEntry;
    }
    if ((0, valueIsNumber_1.default)(startAtEntry)
        || (0, valueIsString_1.default)(startAtEntry) || (0, valueIsBoolean_1.default)(startAtEntry)) {
        startAt = startAtEntry;
    }
    if ((0, valueIsNumber_1.default)(endAtEntry) || (0, valueIsString_1.default)(endAtEntry) || (0, valueIsBoolean_1.default)(endAtEntry)) {
        endAt = endAtEntry;
    }
    let orderBy;
    if ((0, valueIsString_1.default)(orderByEntry) || (0, valueIsString_1.default)(orderByEntry)) {
        orderBy = orderByEntry;
    }
    const onEnd = (data) => {
        executeProcesses(functionId, callbacks.onEnd, data);
    };
    const onError = (message) => {
        executeProcesses(functionId, callbacks.errorProcess, message);
        onEnd();
    };
    if (filter && !orderBy) {
        onError('orderBy is required when the filter is in use');
        return;
    }
    let pathOnDb;
    try {
        pathOnDb = (0, getDbPathFromArrayOfValues_1.default)(arrayPath);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks.errorProcess, errorMessage);
        return;
    }
    let timeToRefresh;
    try {
        timeToRefresh = (0, getIntegerFromUnknown_1.default)(timeToRefreshEntry);
    }
    catch (_a) {
        timeToRefresh = undefined;
    }
    const listener = (snapshot) => {
        const data = snapshot.val();
        if ((0, valueIsNullOrUndef_1.default)(data) || (typeof data === 'object' && Object.keys(data).length === 0)) {
            executeProcesses(functionId, callbacks.onNoData, data);
        }
        else {
            executeProcesses(functionId, callbacks.successProcess, data);
        }
        onEnd(data);
    };
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        onError((0, getErrorMessageNoProjectIdFoundInApp_1.default)('getDataDb'));
        return;
    }
    if (databaseCore && (databaseCore === null || databaseCore === void 0 ? void 0 : databaseCore.read)) {
        databaseCore.read({
            path: pathOnDb,
            timeToRefresh,
            listener,
            isRealTime: !!isRealTime,
            shouldUpdateDbCache: !!shouldUpdateDbCache,
            projectId,
            sendUpdateToDbCache: updateRenderDBCache,
            filter,
            startAt,
            endAt,
            orderBy,
            limitToFirst,
            limitToLast,
            isDevelopment,
        });
    }
};
exports.default = getDataDB;
